import React,{useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import intro from "../../../Images/logo.png";
import intro2 from "../../../Images/logo-dark.png";
import Light from '@material-ui/icons/Brightness7';
import Dark from '@material-ui/icons/Brightness4';
import './Menu.css';

export default function NavBar(props){
    const {theme, setTheme} = props;
    const [media, setMedia] = useState({
        matches: window.matchMedia("(max-width: 1180px)").matches
    });

    useEffect(() => {
        const handler = e => setMedia({matches: e.matches});
        window.matchMedia("(max-width: 980px)").addListener(handler);
    },[])
    
    return(
        <div class="navbar">
            <div className="logo" data-aos="fade-right" data-aos-delay="1100">
                <Link to="/"><img src={theme.mode === 'dark' ? intro2 : intro} className="logo-main" /></Link>
            </div>
            <div className="nav-items">
                <ul>
                    <a href="/work" data-aos="fade-up" data-aos-delay="1000"><li>Work</li></a>
                    <a href="/story" data-aos="fade-up" data-aos-delay="1200"><li>Story</li></a>
                    <a href="/blogs" data-aos="fade-up" data-aos-delay="1400"><li>Blogs</li></a>
                    <a href="https://gumroad.com/vikalp" data-aos="fade-up" data-aos-delay="1600"><li>Products</li></a>
                </ul>
            </div>
            <div className="nav-btn" data-aos="fade-left" data-aos-delay="1100">
                <button className="nav-button" onClick={e => setTheme(
                    theme.mode === 'dark' ? {mode: 'light'} : {mode: 'dark'}
                )}>{theme.mode === 'dark' ? <div><Light fontSize="large" /><div className="nav-btn-text">Light Mode</div></div>: <div><Dark fontSize="large"/><div className="nav-btn-text">Dark Mode</div></div>}</button>
            </div>
            
        </div>
    )
}